/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Col, Form, Input, Row, Typography } from 'antd';

// misc imports
import useTheme from '../../../../utils/hooks/useTheme';
import { FORM_CONFIGURATION_MS_TEAMS_INTEGRATION_PATH } from '../../../../constants/deploymentFormPaths';

const BotDeploymentsMsTeamsStrategyGeneralForm = ({ form, hasEditAccess }) => {
  const { t } = useTranslation();
  const { formProps } = useTheme();

  return (
    <Row gutter={formProps.rowGutter} className={formProps.flexDirection}>
      <Col xs={formProps.mainColSpan}>
        <Row>
          <Col flex="auto">
            <Typography.Text>
              {t('Application Settings')}
            </Typography.Text>

            <Typography.Paragraph className="fs-sm" type="secondary">
              {t('Configure the application settings')}
            </Typography.Paragraph>
          </Col>
        </Row>
      </Col>

      <Col xs={formProps.secondaryColSpan}>
        <Form.Item
          label={t('Client ID')}
          name={[...FORM_CONFIGURATION_MS_TEAMS_INTEGRATION_PATH, 'clientId']}
          rules={[{
            required: true,
            message: t('Please input Client ID')
          }]}
        >
          {
            hasEditAccess
              ? <Input placeholder={t('Enter MS Teams Client ID')} />
              : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_MS_TEAMS_INTEGRATION_PATH, 'clientId'])}</Typography.Text>
          }

        </Form.Item>
        <Form.Item
          label={t('Client Secret')}
          name={[...FORM_CONFIGURATION_MS_TEAMS_INTEGRATION_PATH, 'clientSecret']}
          rules={[{
            required: true,
            message: t('Please input Client Secret')
          }]}
        >
          {
            hasEditAccess
              ? <Input placeholder={t('Enter MS Teams Client Secret')} />
              : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_MS_TEAMS_INTEGRATION_PATH, 'clientSecret'])}</Typography.Text>
          }
        </Form.Item>

        <Form.Item
          label={t('Azure Tenant ID')}
          name={[...FORM_CONFIGURATION_MS_TEAMS_INTEGRATION_PATH, 'azureTenantId']}
          rules={[{
            required: true,
            message: t('Please input Azure Tenant Id')
          }]}
        >
          {
            hasEditAccess
              ? <Input placeholder={t('Enter Azure Tenant ID')} />
              : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_MS_TEAMS_INTEGRATION_PATH, 'azureTenantId'])}</Typography.Text>
          }
        </Form.Item>

        <Form.Item
          label={t('Service URL')}
          name={[...FORM_CONFIGURATION_MS_TEAMS_INTEGRATION_PATH, 'serviceUrl']}
          rules={[{
            required: true,
            message: t('Please input Service URL')
          }]}
        >
          {
            hasEditAccess
              ? <Input placeholder={t('Enter Service URL')} />
              : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_MS_TEAMS_INTEGRATION_PATH, 'serviceUrl'])}</Typography.Text>
          }
        </Form.Item>
      </Col>
    </Row>
  );
};

BotDeploymentsMsTeamsStrategyGeneralForm.propTypes = {
  form: PropTypes.object,
  hasEditAccess: PropTypes.bool
};

export default BotDeploymentsMsTeamsStrategyGeneralForm;
